import getExcelColumnLabel from '@/utils/getExcelColumnLabel'

export function getReferentialColumnDisplayLabel(
  header: string | undefined | null,
  columnIndex: number
): string {
  const trimmed = header?.trim()

  if (trimmed) {
    return trimmed
  }

  return getExcelColumnLabel(columnIndex)
}
